import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';

import "../scss/components/_slider-reviews.scss";

const initPopularArticlesSwiper = () => {
  const sliderPopularArticles = $Q('.popular-articles');

  if (!sliderPopularArticles) return;

  const reviewsQta = parseInt(sliderPopularArticles.dataset.qta);

  new Swiper(sliderPopularArticles, {
    modules: [Pagination, Navigation],
    // autoHeight: true,
    slidesPerView: 4,
    breakpoints: {
      280: {
        spaceBetween: 8,
        slidesPerView: 1.3
      },
      640: {
        spaceBetween: 8,
        slidesPerView: 2

      },
      768: {
        spaceBetween: 8,
        slidesPerView: 3
      },
      992: {
        spaceBetween: 16,
        slidesPerView: 4
      }
    },
    spaceBetween: 8,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button--next' || null,
      prevEl: '.swiper-button--prev' || null,
    },
    autoplay: false
  });

};

export default initPopularArticlesSwiper;
